import { createTheme } from "@mui/material/styles";
import type { BrandTokens } from "../types";

export const createCircuitTheme = (brand: BrandTokens) =>
  createTheme({
    palette: {
      mode: "dark",
      primary: { main: "#4db6ac" },
      secondary: { main: "#9fb4c7" },
      warning: { main: "#f6c453" },
      background: { default: "#0c1116", paper: "#141b24" },
      text: { primary: "#e9eef3", secondary: "rgba(233, 238, 243, 0.7)" }
    },
    shape: { borderRadius: brand.radius + 2 },
    typography: {
      fontFamily: "\"Space Grotesk\", \"Segoe UI\", sans-serif",
      h1: { fontWeight: 600, letterSpacing: "-0.02em", fontSize: "clamp(2.4rem, 4vw, 3.4rem)" },
      h2: { fontWeight: 600, fontSize: "clamp(1.8rem, 3vw, 2.4rem)" },
      h3: { fontWeight: 600, fontSize: "clamp(1.4rem, 2.2vw, 1.9rem)" },
      body1: { fontSize: "1rem", lineHeight: 1.7 },
      body2: { fontSize: "0.95rem", lineHeight: 1.7 },
      button: { textTransform: "none", fontWeight: 600, letterSpacing: "0.01em" }
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          ":root": {
            "--app-bg": "#0c1116",
            "--app-surface": "#141b24",
            "--app-primary": "#4db6ac",
            "--app-accent": "#f6c453"
          },
          body: {
            backgroundColor: "#0c1116",
            backgroundImage:
              "radial-gradient(900px 420px at 15% -10%, rgba(77, 182, 172, 0.16), transparent 60%)," +
              "radial-gradient(720px 360px at 90% 0%, rgba(246, 196, 83, 0.12), transparent 55%)," +
              "linear-gradient(180deg, #0c1116 0%, #101823 60%, #0c1116 100%)",
            color: "#e9eef3"
          },
          "#root": {
            minHeight: "100vh",
            animation: "fadeRise 420ms ease-out"
          },
          "@keyframes fadeRise": {
            from: { opacity: 0, transform: "translateY(6px)" },
            to: { opacity: 1, transform: "translateY(0)" }
          }
        }
      },
      MuiAppBar: {
        defaultProps: { color: "transparent", elevation: 0 }
      },
      MuiPaper: {
        styleOverrides: { root: { backgroundImage: "none" } }
      },
      MuiButton: {
        styleOverrides: {
          root: { borderRadius: brand.radius + 2, padding: "10px 20px" },
          outlined: ({ theme }) => ({
            borderColor: "rgba(77, 182, 172, 0.45)",
            color: theme.palette.primary.main,
            "&:hover": {
              borderColor: theme.palette.primary.main,
              backgroundColor: "rgba(77, 182, 172, 0.12)"
            }
          })
        }
      },
      MuiLink: {
        styleOverrides: { root: { textDecoration: "none", fontWeight: 500 } }
      }
    }
  });
